<template>
  <div class="po-r">
    <div class="login_wrap">
      <div class="login_img">
        <img src="../../assets/logo-red.png" height="36" />
      </div>
      <h3>电子合同下载</h3>
      <div class="login_input">
        <div class="mt20">
          <input :show-clear='false' autofocus v-model="queryParams.mobile" placeholder="请输入手机号">
        </div>
        <div class="mt20" style="position: relative;">
          <input :show-clear='false' autofocus v-model="queryParams.code" ref="numInput" placeholder="验证码">
          <button v-show="verShow" class="send-code" @click="sendCode()">发送验证码</button>
          <button v-show="!verShow" class="send-code"><span>{{ timer }}</span>秒后重新获取</button>
        </div>
      </div>
      <div class="login-btn">
        <button class="sure-btn" @click="goLogin()">登录</button>
      </div>
      <div class="login_tongtong" v-if="isShow">
        <a href="http://sidc.isoftstone.com/test.html"><img class="tongtong" src="../../assets/link.png"></a>
      </div>
    </div>
    <div class="icp-die">
      <p>Copyright©1999-2023，版权所有 软通智服（武汉）科技有限公司</p>
      <p>ICP证：鄂ICP备2022009034号 丨 鄂ICP备2022009034号-1</p>
      <p>增值电信业务经营许可证号：合字B2-20230225</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'contract-login',
  data() {
    return {
      verShow: true,
      timer: 60,
      queryParams: {
        mobile: '',
        code: '',
        _t: Date.parse(new Date()) / 1000
      },
      type: '',
      isShow: true,
      batchNo: ''
    }
  },
  mounted() {
    this.type = this.getCode('type')
    this.batchNo = this.getCode('batchNo')
    if (this.type && this.type === 'employeeResign') {
      this.queryParams.scenario = 1
      this.isShow = false
    } else if (this.type && this.type === 'localContract') {
      this.queryParams.batchNo = this.batchNo
      this.isShow = true
    } else if (this.type && this.type === 'extendContract') {
      this.isShow = true
    }  else if (this.type && this.type === 'transferContract') {
      this.isShow = true
    } else {
      this.queryParams.scenario = 0
      this.isShow = true
    }
    localStorage.setItem('contractType', this.type)
  },
  methods: {
    getCode(type) {
      return (
        decodeURIComponent(
          (new RegExp('[?|&]' + type + '=' + '([^&;]+?)(&|#|;|$)').exec(
            location.href
          ) || [, ''])[1].replace(/\+/g, '%20')
        ) || null
      )
    },
    sendCode() {
      let telReg = /^1[3456789][0-9]{9}$/
      if (!this.queryParams.mobile) {
        this.$Message.error('请输入手机号')
        return
      }
      if (!telReg.test(this.queryParams.mobile)) {
        this.$Message.error('请输入正确的手机号')
        return
      }
      var ts = this
      axios
        .get(process.env.BASE_API + '/contract/api/getAuthCode', {
          params: {
            mobile: this.queryParams.mobile,
            _t: Date.parse(new Date()) / 1000
          }
        })
        .then(function (res) {
          if (res.data.code == 0) {
            ts.$Message.info('验证码发送成功！')
            ts.verShow = false
            let auth_timer = setInterval(() => {
              ts.timer--
              if (ts.timer <= 0) {
                ts.verShow = true
                ts.timer = 60
                clearInterval(auth_timer)
              }
            }, 1000)
          } else {
            ts.$Message.error(res.data.message)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    goLogin() {
      let telReg = /^1[3456789][0-9]{9}$/
      if (!this.queryParams.mobile) {
        this.$Message.error('请输入手机号')
        return
      }
      if (!telReg.test(this.queryParams.mobile)) {
        this.$Message.error('请输入正确的手机号')
        return
      }
      if (!this.queryParams.code) {
        this.$Message.error('请输入验证码')
        return
      }

      let ts = this
      let url = process.env.BASE_API + '/contract/api/queryEmployeeContract'
      if (this.type == 'localContract') {
        url = process.env.BASE_API + '/localContract/api/queryEmployeeContract'
      } else if (this.type == 'extendContract') {
        url = process.env.BASE_API + '/extendContract/api/queryEmployeeContract'
      } else if (this.type == 'transferContract') {
        url = process.env.BASE_API + '/transferContract/api/queryEmployeeContract'
      }
      axios.get(url, {
        params: this.queryParams
      }
      )
        .then(function (res) {
          if (res.data.code == 0) {
            sessionStorage.setItem(
              'contractList',
              JSON.stringify(res.data.data)
            )
            ts.$router.push({ path: '/contract-download' })
          } else {
            ts.$Message.error(res.data.message)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style scoped>
.po-r {
  position: relative;
  padding-bottom: 120px;
}

.icp-die {
  width: 100%;
  text-align: center;
  font-size: 12px;
  color: #c7c8cf;
  padding: 20px 0;
  line-height: 25px;
  position: absolute;
  bottom: 0px
}

input {
  outline: none !important;
}

.login_img {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

img {
  margin-top: 50px;
}

.login_wrap h3 {
  font-size: 20px;
  color: #333333;
  letter-spacing: 0;
  text-align: center;
  line-height: 20px;
  margin-top: 30px;
  font-weight: bolder;
}

.login_input {
  padding: 40px;
  box-sizing: border-box;
}

.login-btn {
  display: flex;
  justify-content: space-around;
  padding: 0 30px;
}

.login-btn .sure-btn {
  width: 100%;
  height: 48px;
  border: 0;
  border-radius: 24px;
  color: #fff;
  background: #efefef;
  font-size: 17px;
  box-shadow: 0 18px 18px 0 rgba(10, 31, 68, 0.12);
  background-image: linear-gradient(240deg, #ed4243, #d61f20);
}

.login_input input {
  height: 100%;
  background: #f2f2f2;
  width: 100%;
  overflow: hidden;
  padding: 14px 15px !important;
  font-size: 14px;
  border-radius: 5px;
  border: 0;
}

.send-code {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  color: #d61f20;
  font-size: 14px;
  font-weight: bold;
  border: 0;
  background: transparent;
  padding: 0 10px;
}

.tongtong {
  width: 100%;
}

.login_tongtong {
  text-align: center;
}

@media screen and (min-width: 1024px) {
  .login_input {
    margin: 0px 35%;
  }

  .login-btn .sure-btn {
    width: 28%;
  }

  .tongtong {
    width: 375px;
  }
}

/* @media screen and (min-height: 737px) {
  .login_tongtong {
    position: fixed;
    bottom: 0;
    width: 100%;
  }
} */
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue